import React, { useState, useEffect } from "react"
import { Modal } from "react-bootstrap"
import {
  CardElement,
  IbanElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js"
import StripeLogo from "../../assets/images/stripeLogo.png"
import WorkeyeLogo from "../../assets/images/WE_text_tick.png"
import { useStaticQuery, graphql } from "gatsby"
import $ from "jquery"
import "../../styles/ibanFormStyles.css"

const Checkout = ({
  planamount,
  planname,
  fullName,
  companyName,
  email,
  paymentMethod,
  btnText,
  toggleInvoice,
}) => {
  const data = useStaticQuery(graphql`
    query {
      allContentfulTestDrivePlans(sort: { fields: createdAt }) {
        nodes {
          taxText
          thankYouTextOne
          thankYouTextTwo
        }
      }
    }
  `)
  const { allContentfulTestDrivePlans } = data

  const [showCheckoutForm, setShowCheckoutForm] = useState(false)
  const [showThankYouMsg, setShowThankYouMsg] = useState(false)
  const [error, setError] = useState(null)
  const [processing, setProcessing] = useState(false)
  const [disabled, setDisabled] = useState(true)
  const stripe = useStripe()
  const elements = useElements()

  useEffect(() => {
    // center popup box on screen
    $(".modal-dialog").addClass("modal-dialog-centered")

    // change font size of sepa button on different screen sizes
    if (paymentMethod === "sepa") {
      $("#checkoutButton").addClass("sepaButton")
    } else {
      $("#checkoutButton").removeClass("sepaButton")
    }
  })

  let amount = planamount * 100

  const cardStyle = {
    hidePostalCode: true,
    style: {
      base: {
        color: "#32325d",
        fontFamily: "Arial, sans-serif",
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "#32325d",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
  }

  const IBAN_STYLE = {
    base: {
      color: "#32325d",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
      ":-webkit-autofill": {
        color: "#32325d",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
      ":-webkit-autofill": {
        color: "#fa755a",
      },
    },
  }

  const IBAN_ELEMENT_OPTIONS = {
    supportedCountries: ["SEPA"],
    // Elements can use a placeholder as an example IBAN that reflects
    // the IBAN format of your customer's country. If you know your
    // customer's country, we recommend that you pass it to the Element as the
    // placeholderCountry.
    placeholderCountry: "DE",
    style: IBAN_STYLE,
  }

  const showError = errorMsgText => {
    //changeLoadingState(false);
    let errorMsg = document.querySelector("#error-message")
    errorMsg.textContent = errorMsgText
    // setTimeout(function () {
    //   errorMsg.textContent = ""
    // }, 4000)
    document.getElementById("sepa-submit").style.display = "none"
  }

  const handleChange = async event => {
    // Listen for changes in the CardElement
    // and display any errors as the customer types their card details
    setDisabled(event.empty)
    setError(event.error ? event.error.message : "")

    if (event.error) {
      document.getElementById("card-submit").style.display = "none"
    } else {
      document.getElementById("card-submit").style.display = "block"
    }
  }

  const handleSubmitCard = async event => {
    event.preventDefault()
    setProcessing(true)

    getClientSecret()

    async function getClientSecret() {
      const response = await fetch("/.netlify/functions/create-intent", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          accountholderName: fullName,
          name: companyName,
          email: email,
          planType: planname,
          amount: amount,
        }),
      })
        .then(response => response.json())
        .then(handleResponse)
    }

    async function handleResponse(json) {
      sendToDatabase()

      async function sendToDatabase() {
        const paymentData = {
          name: json.name,
          email: json.email,
          planType: planname,
          payment: paymentMethod,
        }

        const response = await fetch("/.netlify/functions/store-customer", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(paymentData),
        })

        return response.json()
      }

      const clientSecret = json.clientSecret

      const payload = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
        },
      })
      if (payload.error) {
        setError(`Payment failed ${payload.error.message}`)
        setProcessing(false)
      } else {
        setError(null)
        setProcessing(false)
      }

      setShowCheckoutForm(false)
      setShowThankYouMsg(true)
    }
  }

  const handleSubmitSepa = async event => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault()

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return
    }

    const iban = elements.getElement(IbanElement)

    bankTransfer()

    async function bankTransfer() {
      const paymentData = {
        accountholderName: fullName,
        name: companyName,
        email: email,
        planType: planname,
        amount: amount,
      }

      const res = await fetch("/.netlify/functions/bank-transfer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(paymentData),
      })
        .then(response => response.json())
        .then(handleResponse)
    }

    async function handleResponse(json) {
      const iban = elements.getElement(IbanElement)

      sendToDatabase()

      async function sendToDatabase() {
        const paymentData = {
          name: json.name,
          email: json.email,
          planType: planname,
          payment: paymentMethod,
        }

        const response = await fetch("/.netlify/functions/store-customer", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(paymentData),
        })

        return response.json()
      }

      stripe.confirmSepaDebitPayment(json.secret, {
        payment_method: {
          sepa_debit: iban,
          billing_details: {
            name: json.name,
            email: json.email,
          },
        },
      })

      setShowCheckoutForm(false)
      setShowThankYouMsg(true)
    }
  }

  const formContentCard = () => {
    return (
      <>
        <div class="w-100 p-3">
          <div className="form-column">
            <label>Card Details</label>
            <CardElement
              id="card-element"
              options={cardStyle}
              onChange={handleChange}
            />
          </div>
        </div>

        <center>
          {/* Show any error that happens when processing the payment */}
          {error && (
            <div className="card-error" class="text-danger pt-3" role="alert">
              {error}
            </div>
          )}

          <button
            className="btn btn-primary mt-3"
            disabled={processing || disabled}
            id="card-submit"
          >
            <span id="button-text">
              {processing ? (
                <div className="spinner" id="spinner"></div>
              ) : (
                "Pay"
              )}
            </span>
          </button>

          <div>
            <img src={StripeLogo} alt="Stripe Logo" classname="stripeLogo" />
            <img
              src={WorkeyeLogo}
              alt="Workeye Logo"
              classname="workeyeLogo"
              height={40}
            />
          </div>
        </center>
      </>
    )
  }

  const formContentSepa = () => {
    return (
      <>
        <div class="w-100 p-3">
          <div className="form-column">
            <label>IBAN</label>
            <IbanElement
              options={IBAN_ELEMENT_OPTIONS}
              onChange={event => {
                if (event.error) {
                  showError(event.error.message)
                } else {
                  showError("")
                  document.getElementById("sepa-submit").style.display = "block"
                }
              }}
            ></IbanElement>
          </div>
        </div>

        <div
          id="error-message"
          role="alert"
          class="text-danger pt-3 text-center"
        ></div>

        <center>
          <button
            id="sepa-submit"
            type="submit"
            className="btn btn-primary"
            disabled={!stripe}
          >
            Pay
          </button>
        </center>
        {/* Display mandate acceptance text. */}
        <center>
          <div>
            <img
              src={StripeLogo}
              alt="Stripe Logo"
              classname="stripeLogo"
              height={100}
            />
            <img
              src={WorkeyeLogo}
              alt="Workeye Logo"
              classname="workeyeLogo"
              height={40}
            />
          </div>
        </center>
        <div class="w-100 p-3">
          <div className="mandate-acceptance">
            By providing your payment information and confirming this payment,
            you authorise (A) Workeye and Stripe, our payment service provider,
            to send instructions to your bank to debit your account and (B) your
            bank to debit your account in accordance with those instructions. As
            part of your rights, you are entitled to a refund from your bank
            under the terms and conditions of your agreement with your bank. A
            refund must be claimed within 8 weeks starting from the date on
            which your account was debited. Your rights are explained in a
            statement that you can obtain from your bank. You agree to receive
            notifications for future debits up to 2 days before they occur.
          </div>
        </div>
      </>
    )
  }

  const resetForm = () => {
    setError(null)
    setProcessing(false)
    setDisabled(true)
  }

  return (
    <div>
      <button
        type="button"
        className="btn btn-primary"
        id="checkoutButton"
        onClick={() => {
          setShowCheckoutForm(true)
          $(".invoice-popup").css("display", "none")
        }}
      >
        {btnText}
      </button>
      <Modal
        show={showCheckoutForm}
        onHide={() => {
          resetForm()
          setShowCheckoutForm(false)
          $(".invoice-popup").css("display", "block")
        }}
        className="main-text-color"
      >
        <Modal.Header closeButton>
          <Modal.Title>{btnText}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={
              paymentMethod === "card" ? handleSubmitCard : handleSubmitSepa
            }
          >
            <div className="text-center" style={{ marginBottom: "20px" }}>
              <p>
                <h4>{planname}</h4>
              </p>
              <p>
                <h4>
                  <b>€{planamount.toFixed(2)}</b>
                </h4>
              </p>
              {allContentfulTestDrivePlans.nodes[0].taxText}
            </div>

            <div className="form-row inline">
              <div class="w-100">
                <div className="col">
                  <label>
                    <div className="input-text">Full Name</div>
                    <div class="w-100 p-2">
                      <input
                        className="input-box"
                        name="accountholder-name"
                        value={fullName}
                        disabled
                      />
                    </div>
                  </label>
                </div>
              </div>

              <div class="w-100">
                <div className="col">
                  <label>
                    <div className="input-text">Email Address</div>
                    <div class="w-100 p-2">
                      <input
                        className="input-box"
                        name="email"
                        type="email"
                        value={email}
                        disabled
                      />
                    </div>
                  </label>
                </div>
              </div>

              <div class="w-100">
                <div className="col">
                  <label>
                    <div className="input-text">Company Name</div>
                    <div class="w-100 p-2">
                      <input
                        className="input-box"
                        name="company-name"
                        value={companyName}
                        disabled
                      />
                    </div>
                  </label>
                </div>
              </div>
            </div>

            {paymentMethod === "card" ? formContentCard() : formContentSepa()}
          </form>
        </Modal.Body>
      </Modal>
      <Modal
        show={showThankYouMsg}
        onHide={() => {
          setShowThankYouMsg(false)
          toggleInvoice()
        }}
        className="main-text-color"
      >
        <Modal.Header closeButton>
          {allContentfulTestDrivePlans.nodes[0].thankYouTextOne}
        </Modal.Header>
        <Modal.Body>
          {allContentfulTestDrivePlans.nodes[0].thankYouTextTwo}
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default Checkout
